import { Decimal, Format, PercentageFormatter } from '@zervant/reactcomponents'

const MAX_PRICE = 999999999999.99

export function convertPctFromLocale(value, locale) {
  const pctFormat = Format.fromLocale(locale)
  const percent = new Decimal(value).times(100).toNumber()
  const isDecimal = !Number.isInteger(percent)
  pctFormat.numbers.decimalAccuracy = 1
  const percentageF = new PercentageFormatter(pctFormat, isDecimal)
  return percentageF.render(percent)
}

export function isPriceValid(value: number) {
  return value < MAX_PRICE
}

export function isNonVatPriceValid(nonVatPrice: number, vatPct: number) {
  return isPriceValid(nonVatPrice * (1 + vatPct))
}
